<template>
	<Modal
		:show="showSchemeDetails"
		content_class="col-12 col-md-9 col-lg-8 col-xl-7 view-scheme-details"
	>
		<template slot="content">
			<div>
				<div class="clearfix top">
					<div class="left-content f-l">
						<div class="content-title">View Scheme Details</div>
						<div class="subtitle" v-if="selected_scheme">
							{{ selected_scheme.scheme_name }} Group Membership
						</div>
					</div>
					<div
						class="close-modal f-r"
						@click="$store.commit('showSchemeDetails', false)"
					>
						<i class="fa fa-times"></i>
					</div>
				</div>

				<div class="scheme" v-if="scheme_details">
					<div class="card card-details">
						<div class="clearfix">
							<div
								class="status"
								v-if="scheme_details.scheme_member_status"
								:class="{
									green:
										scheme_details.scheme_member_status ===
										'ACTIVE',
								}"
							>
								{{
									scheme_details.scheme_member_status
										.split(':')
										.join(' ')
								}}
							</div>
							<div class="ref">
								{{
									scheme_details.group_details
										.system_scheme_group_ref
								}}
							</div>
							<div class="blue">
								{{
									scheme_details.group_details
										.scheme_group_type
								}}
							</div>
							<div class="name">
								Added on:
								<b>{{
									moment(scheme_details.created_date).format(
										'Do MMM YYYY HH:mm',
									)
								}}</b>
							</div>
							<div class="name">
								{{
									scheme_details.group_details
										.scheme_group_name
								}}
							</div>
							<div class="name">
								{{
									scheme_details.group_details
										.scheme_group_description
								}}
							</div>
							<div
								class="btn-bottom mt-4"
								v-if="
									scheme_details.scheme_member_status ===
									'PENDING:ACCEPTANCE'
								"
							>
								<div class="row">
									<div class="col-md-6">
										<div
											class="btn btn-long btn-green"
											@click="
												acceptGroupScheme(
													scheme_details.system_scheme_member_ref,
												)
											"
										>
											Accept <i class="fa fa-check"></i>
										</div>
									</div>
									<div class="col-md-6">
										<div
											class="btn btn-long btn-red"
											@click="
												rejectGroupScheme(
													scheme_details.system_scheme_member_ref,
												)
											"
										>
											Reject <i class="fa fa-ban"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					class="product"
					v-for="(product, i) in scheme_products"
					:key="i"
				>
					<!-- <div class="ribbon primary right">Promotion</div> -->
					<div
						class="ribbon primary right"
						v-if="
							product.token_details &&
							product.token_details.token_discount_type ===
								'PERCENTAGE'
						"
					>
						{{ product.token_details.token_discount_value }}% Off
					</div>
					<div
						class="ribbon primary right"
						v-if="
							product.token_details &&
							product.token_details.token_discount_type ===
								'FIXED'
						"
					>
						KES {{ product.token_details.token_discount_value }} Off
					</div>
					<div class="row">
						<div class="col-12">
							<div class="row">
								<div class="col-12 col-md-6 col-lg-4">
									<div class="image-box">
										<div class="icon-box">
											<i class="fa fa-heart"></i>
										</div>
										<img
											:src="
												product.product_details.logo
													? api.getDomain() +
														product.product_details
															.logo
													: '/img/logo-1.png'
											"
											alt=""
											class="image"
										/>
									</div>
								</div>
								<div
									class="col-12 col-md-6 col-lg-8 content-sec"
								>
									<div class="title">
										{{
											product.product_details.product_name
										}}
									</div>
									<div class="desc clearfix">
										<div class="desc-unit">
											<div class="d-title">
												Underwritter
											</div>
											<div class="d-text">
												{{
													product.underwriter_details
														.name
												}}
											</div>
										</div>
										<div class="desc-unit">
											<div class="d-title">
												Minimum Premium
											</div>
											<div class="d-text tx-red">
												KES
												{{
													utils.numberWithCommas(
														product.product_details
															.minimum_premium,
													)
												}}
											</div>
										</div>
									</div>
									<div class="clearfix">
										<div
											class="btn btn-grey btn-long mt-4"
											@click="viewProduct(product)"
										>
											<i class="fa fa-eye"></i>
											View Product
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 contents">
							<div class="row">
								<div class="col-12">
									<div class="summary">
										<div class="title">Summary</div>
										<div class="desc">
											{{
												product.product_details
													.description
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import profile from '../rsc/stores/profile.store';

export default {
	beforeCreate() {
		Event.$emit('loader:show', true);
	},
	beforeDestroy() {
		this.$store.unregisterModule('profile');
	},
	created() {
		utils.registerModule('profile', profile, this.$store);
	},
	components: {
		Modal: () => import('../templates/others/modal'),
		Form: () => import('@/libs/clarks/components/form'),
	},
	data() {
		return {
			moment,
			utils,
			api,
		};
	},
	computed: {
		...mapGetters([
			'showSchemeDetails',
			'selected_scheme',
			'scheme_details',
			'scheme_products',
		]),
	},
	methods: {
		...mapActions(['fetchData', 'acceptGroupScheme', 'rejectGroupScheme']),
		async viewProduct(product) {
			if (
				product.token_details &&
				product.token_details.token_discount_value &&
				product.token_details.token_discount_value > 0
			) {
				await $session.set('promotion', {
					token: product.token_details,
					product: product.product_details,
					system_scheme_member_ref:
						this.scheme_details.system_scheme_member_ref,
				});
			}
			this.$router.push({
				name: 'ViewProduct',
				params: { id: product.product_details.product_id },
			});
		},
	},
	async mounted() {
		utils.registerModule('profile', profile, this.$store);
	},
};
</script>

<style lang="less">
@grey: #a7abbd;
@background-grey: #f9f9f9;

.view-scheme-details {
	.product {
		box-shadow: 0 10px 14px 0 #45495b14;
		background-color: #ffffff;
		padding: 15px 20px 0 20px;
		margin: 10px 0;

		.ribbon.left {
			left: calc(4.1rem) !important;
		}
		.all-features {
			background: #f9f9f9;

			.icon {
				text-align: center;
				color: #898ea2;
				margin: 50px 20px;

				i {
					font-size: 32px;
				}
				.txt {
					font-size: 13px;
				}
			}
		}
		.contents {
			border-top: solid 2px #f7f8fc;

			.last-content.col-12 {
				padding: 10px 15px !important;
			}
			.bottom {
				// position: absolute;
				bottom: 0;
				left: 0;
				right: 0;
				margin: 0 -15px 0 0;

				.customization {
					padding: 20px 15px;
					text-align: center;

					.txt {
						color: #a7abbd;
						font-size: 15px;
						margin: 15px 0;

						span {
							color: #666ee8;
							font-weight: 600;
						}
					}
				}
				.actions {
					display: flex;
					margin: 0 3px 0 0;

					.btn {
						width: 100%;
						border-radius: 0;
					}
				}
			}
		}
		.summary {
			padding: 20px 0 45px 0;

			.title {
				font-size: 15px;
				font-weight: 600;
				margin: 5px 0;
				color: #464855;

				.txt {
					margin: 2px 0 0 0;
				}
			}
			.desc {
				font-size: 13px;
			}
			.features {
				margin: 5px 0;
				font-size: 14px;
				color: #a7abbd;

				.name {
					font-weight: 600;
				}
				.icon {
					margin: 1px 10px 0 0;
				}
			}
		}
		.ne-actions {
			padding: 0 20px;
			border-left: solid 2px #f7f8fc;

			.btn {
				width: 100%;
				margin: 5px 0;
			}
			.btn:first-child {
				margin: 0 0 5px 0;
			}
		}
		.offer-box {
			text-align: right;
			margin: 0 15px 0 0;

			.regular {
				color: var(--text-grey);
				font-family: var(--font-bold);
			}
			.offer {
				font-size: 18px;
				font-family: var(--font-bold);
			}
			.save {
				font-size: 12px;
				color: var(--text-grey);
			}
		}
		.content-sec {
			.title {
				font-family: var(--font-bolder);
				font-weight: 700;
				font-size: 18px;
				color: var(--ne-blue);
				margin: 0 0 10px 0;
			}
			.ne-badge {
				float: left;
				padding: 1px 8px;
				background: @background-grey;
				margin: 0 10px 0 0;
				color: var(--text-color);
				border-radius: 5px;
				font-size: 13.5px;
			}

			.desc {
				margin: 20px 0 0 0;

				.desc-unit {
					float: left;
					margin: 0 20px 0 0;

					.d-title {
						font-size: 13px;
						color: var(--text-grey);
					}
					.d-text {
						font-family: var(--font-bold);
						color: var(--text-color);
					}
				}
			}
		}
		.image-box {
			border-radius: 5px;
			background-color: @background-grey;
			text-align: center;
			position: relative;
			height: 90%;
			width: 100%;

			.icon-box {
				position: absolute;
				right: 10px;
				top: 5px;
				background: #00000066;
				color: var(--white);
				padding: 3px 7px;
				border-radius: 2px;
				cursor: pointer;

				i {
					font-size: 12px;
				}
			}
			.image {
				max-width: 100%;
				height: auto;
				margin: 20% 0 20% 0;
				// max-width: 100%;
				max-height: 100px;
			}
		}
	}
}
</style>
